/*
 * @Author: ZS
 * @Date: 2020-07-08 09:57:34
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-15 16:50:41
 * @Description: 一些公共方法
 */
import Axios from 'axios';
import {
  ywtbRequest
} from './api/axios'
import Vue from 'vue';
import store from '@/store/store';
import qs from 'qs';
export default {
  // 人中心的时间转换
  renderTime(date) {
    var dateee = new Date(date).toJSON();
    return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  },
  // 收藏和取消收藏
  collection: function (item, callback) {
    let sendData = qs.stringify({
      collectionGuidelineCode: item.portalPcHandlingGuidelineCode
    });
    // console.log(item);
    //如果未收藏就发送收藏请求,否则发送取消收藏请求
    let url;
    if (item.portalPcHandlingGuidelineCollection == 1) {
      url = '/portal-ywtb/web/collection/deleteCollection'
    } else if (item.portalPcHandlingGuidelineCollection == 0) {
      url = '/portal-ywtb/web/collection/addCollection'
    } else {
      return
    }
    ywtbRequest(url,sendData).then(res => {
      if (res.status == 200) {
        Vue.prototype.$message({
          message: '操作成功',
          type: 'success'
        });
        if (item.portalPcHandlingGuidelineCollection == 1) {
          item.portalPcHandlingGuidelineCollection = 0
        } else if (item.portalPcHandlingGuidelineCollection == 0) {
          item.portalPcHandlingGuidelineCollection = 1
        }
        if (typeof callback === "function") {
          callback(item.portalPcHandlingGuidelineCollection);
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/publicMethod.js